import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { Auth } from 'aws-amplify'
import { CSSTransition } from 'react-css-transition'
import Textbox from '../Textbox'
import Button from '../Button'
import Spinner from '../Spinner'
import TransitionStyles from '../../lib/transitionStyles'

class ImportedMemberSignup extends Component {

  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      confirmPassword: '',
      showValidationError: false,
      showSubmittedMsg: false,
      isLoading: false,
      errorMsg: {}
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.afterSignupAction = props.afterSignupAction.bind(this)
  }

  handleChange(event) {
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  async handleSubmit(e) {
    e.preventDefault()
    const { email, password, confirmPassword } = this.state
    
    if (password === confirmPassword) {
      this.setState({ isLoading: true })
      try {
        await Auth.signUp({
          username: email && email.toLowerCase(),
          password,
          attributes: {
            email: email && email.toLowerCase()
          }
        })
        this.setState({ 
          isLoading: false,
          showSubmittedMsg: true,
          showValidationError: false,
         })
      } catch (error) {
        this.setState({ 
          isLoading: false,
          showValidationError: true,
          errorMsg: { header: <FormattedMessage id="login.importedMember.problemCreatingErrorMsg" defaultMessage="There was a problem creating the account" />, text: error.message || error || ''}
        })
      }
    } else {
      this.setState({ showValidationError: true, errorMsg: { header: <FormattedMessage id="login.importedMember.passwordLabel" defaultMessage="Password" />, text: <FormattedMessage id="login.forgotpass.twoPasswordsNotIdentical" defaultMessage="The two passwords are not identical" /> } })
    }
  }

  renderForm() {
    const { email, password, confirmPassword, showValidationError, errorMsg } = this.state

    return (
      <form onSubmit={this.handleSubmit}>

        <div className="mt-4">
          <label
            htmlFor="email"
            className="text-sky text-sm font-bold"
          >
            E-mail
            <div>
              <Textbox
                htmlId="email"
                htmlName="email"
                type="text"
                value={email}
                onChange={this.handleChange}
                className="w-full md:w-1/2"
              />
            </div>
          </label>
        </div>

        <div className="mt-4">
          <label
            htmlFor="password"
            className="text-sky text-sm font-bold"
          >
            <FormattedMessage id="login.importedMember.passwordLabel" defaultMessage="Password" />
            <div>
              <Textbox
                htmlId="password"
                htmlName="password"
                value={password}
                onChange={this.handleChange}
                type="password"
                className="w-full md:w-1/2"
              />
            </div>
          </label>
        </div>

        <div className="mt-4">
          <label
            htmlFor="confirmPassword"
            className="text-sky text-sm font-bold"
          >
            <FormattedMessage id="login.importedMember.repeatPasswordLabel" defaultMessage="Repeat password" />
            <div>
              <Textbox
                htmlId="confirmPassword"
                htmlName="confirmPassword"
                value={confirmPassword}
                onChange={this.handleChange}
                type="password"
                className="w-full md:w-1/2"
              />
            </div>
          </label>
        </div>

        {showValidationError && (
          <CSSTransition {...TransitionStyles} transitionAppear active>
            <div className="text-sm mt-4 bg-red-lightest border-l-2 border-red text-red-dark p-2" role="alert">
              <p className="font-bold m-0">
                {errorMsg.header}
              </p>
              <p className="m-0">
                {errorMsg && errorMsg.text}
                {/* Vi kan ikke finde dit brugernavn, eller også er dit password forkert. */}
              </p>
            </div>
          </CSSTransition>
        )}

        <div className="flex justify-end mt-8">
          <Button>
            <FormattedMessage
              id="login.importedMember.activateAndSaveLabel"
              defaultMessage="Activate and save"
            />
          </Button>
        </div>
      </form>      
    )
  }

  render() {
    const { isLoading, showSubmittedMsg, email, password } = this.state

    if (isLoading) {
      return <Spinner />
    }
    
    return (
      <>
        <h1>
          <FormattedMessage
            id="booking.amountForm.login.activateMembership"
            defaultMessage="Activate membership"
          />
        </h1>

        {showSubmittedMsg ? (
          <>
            <div className="mt-8">
              <FormattedMessage
              id="login.importedMember.ski365MembershipActivatedMsg"
              defaultMessage="Your SKI365 membership has been activated. You can now login."
              />
            </div>
            <div className="flex justify-end mt-8">
              <Button onClick={() => {this.afterSignupAction(email, password)}}>
                <FormattedMessage
                id="login.forgotpass.goToLogin"
                defaultMessage="Go to login"
                />
              </Button>
            </div>
          </>
        ) : (
          this.renderForm()
        )}
      </>
    )
  }
}

ImportedMemberSignup.propTypes = {
  afterSignupAction: PropTypes.func.isRequired
}

export default ImportedMemberSignup